import GenericModel from './generic-model';

export default class Coordinates extends GenericModel {
  lat?: number;
  lng?: number;

  constructor() {
    super();
  }

  static of(lat: number, lng: number): Coordinates {
    const coordinates = new Coordinates();
    coordinates.lat = lat;
    coordinates.lng = lng;
    return coordinates;
  }
}
